import { Box } from "@mui/material";
import { FEED_BOX_PANELS, FEED_CONTENT_PANELS_ID, FEED_FILTER_AREA_ID, FEED_PUB_HEADER, FEED_RIGHT_PANEL_WIDTH } from "app/appConstants";
import { AppGlobalClassKeys } from "app/appGlobalStyles";
import { MprcCard } from "components/MprcCard";
import { useWindowSize } from "hooks/useWindowSize";
import { INSIDE_LAYOUT_CONTENT_CONTAINER_ID } from "layouts/common/inside/MprcLayoutInside";
import * as React from "react";
import { useEffect, useRef } from "react";

export const FeedBoxPanels: React.FC<React.PropsWithChildren> = ({ children }) => {
    const { height: windowHeight } = useWindowSize();
    const boxRef = useRef<HTMLDivElement>(undefined!);

    const c = React.Children.toArray(children);

    /** Ajusta a Altura Inicial da Área Lateral Direita */
    useEffect(() => {
        const container = document.getElementById(INSIDE_LAYOUT_CONTENT_CONTAINER_ID);
        if (container && boxRef.current) {

            const rightPanel = document.getElementById(FEED_BOX_PANELS);
            if (rightPanel) {
                const cs = getComputedStyle(container);
                let barHeight = 0;

                const barContainer = document.getElementById(FEED_FILTER_AREA_ID);
                if (barContainer) {
                    const enrollmentViewBarCs = getComputedStyle(barContainer);
                    barHeight = parseInt(enrollmentViewBarCs.height) + parseInt(enrollmentViewBarCs.marginBottom) + parseInt(enrollmentViewBarCs.marginTop);
                }

                const pubHeader = document.getElementById(FEED_PUB_HEADER);
                if (pubHeader) barHeight += pubHeader.clientHeight;

                rightPanel.style.height = (parseInt(cs.height) - barHeight) + "px";
            }
        }
    }, [boxRef.current, windowHeight]);



    return c.length > 0 && (
        <MprcCard id={FEED_BOX_PANELS} className={AppGlobalClassKeys.hiddenIfEmpty}
            sx={
                ({
                    width: FEED_RIGHT_PANEL_WIDTH,
                    overflowY: "auto",
                    "::-webkit-scrollbar": {
                        width: 8,
                        height: 8,
                    },
                    "::-webkit-scrollbar-track": {
                        backgroundColor: "transparent",
                    },
                    "::-webkit-scrollbar-thumb": {
                        backgroundColor: "transparent",
                        borderRadius: "50px",
                        border: "3px solid transparent"
                    },
                    "&:hover": {
                        "::-webkit-scrollbar-thumb": {
                            backgroundColor: "grey",
                            border: "3px solid grey"
                        },
                        "::-webkit-scrollbar-track": {
                            backgroundColor: "lightgray",
                        }
                    }
                })
            }
        >
            <Box id={FEED_CONTENT_PANELS_ID} ref={boxRef} display="flex" flexDirection="column" rowGap={5.5} padding={2}>
                {
                    c.map((child, index) => {
                        return (
                            <Box key={index} className={AppGlobalClassKeys.hiddenIfEmpty}>
                                {child}
                            </Box>
                        );
                    })
                }
            </Box>
        </MprcCard>
    );
};

export const FeedDrawerPanels: React.FC<React.PropsWithChildren> = ({ children }) => {
    const c = React.Children.toArray(children);
    return c.length > 0 && (
        <MprcCard id="feedDrawerPanels" className={AppGlobalClassKeys.hiddenIfEmpty} borderRadius="none" elevation={0}>
            <Box display="flex" flexDirection="column" rowGap={4}>
                {
                    c.map((child, index) => {
                        return (
                            <Box key={index} className={AppGlobalClassKeys.hiddenIfEmpty}>
                                {child}
                            </Box>
                        );
                    })
                }
            </Box>
        </MprcCard>
    );
};
